import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from 'src/app/helpers/helpers';
import { UserService } from 'src/app/services/user.service';
import { visibleContentAnimation } from 'src/app/animations';

@Component({
  templateUrl: './conditions-accept.component.html',
  styleUrls: ['./conditions-accept.component.css'],
  animations: [
    visibleContentAnimation
  ]
})
export class ConditionsAcceptComponent implements OnInit {

  isAdminConce: boolean;
  loaded = false;
  userIsR2: boolean;

  constructor(
    private userService: UserService, private router: Router, public helpers: Helpers
  ) { }

  ngOnInit(): void {

    this.getUserInfo();

  }

  getUserInfo() {
    this.userService.userData.subscribe(resp => {
      if (resp) {
        this.userIsR2 = resp.IsR2;
        this.isAdminConce = (resp.RolesListString.includes("ResponsablePv") || resp.RolesListString.includes("ResponsablePvR2") || resp.RolesListString.includes("Administrador") || resp.RolesListString.includes("AdminRenault"));
      }
      this.loaded = true;
    });
  }

  setConditions() {
    this.userService.SetConditionsDistributor().subscribe(res => {

      this.router.navigate(['/home']);

    });
  }

}
